<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-tile-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {Tile} from "@/modules/redactor/models/utils/Tile";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RTileTable from "@/modules/redactor/views/utils/r-tile-table.vue";

export default {
  name: "r-tile-panel",
  components: {RTileTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Cells"),
    items: VueTypes.arrayOf(Tile)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>